import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-week-to-date',
  templateUrl: './week-to-date.component.html',
  styleUrls: ['./week-to-date.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class WeekToDateComponent {
  @Input() dashboardData: any;
  weekTargetTop: any;
  weekTargetBottom: any;
  weekDriveThruOrdersTop: any;
  weekDriveThruOrdersBottom: any;
  weekDriveThruSalesTop: any;
  weekDriveThruSalesBottom: any;
  weekLabourPerTop: any;
  weekLabourPerBottom: any;
  weekOnlineCustomerOrdersTop: any;
  weekOnlineCustomerOrdersBottom: any;
  weekOnlineSalesTop: any;
  weekOnlineSalesBottom: any;
  weekSalesTop: any;
  weekSalesBottom: any;
  weekLabourHoursTop: any;
  weekLabourHoursBottom: any;
  weekCustomerOrdersBottom: any;
  weekCustomerOrdersTop: any;
  weekLabourCostBottom: any;
  weekLabourCostTop: any;
  weekItemsSoldTop: any;
  weekItemsSoldBottom: any;
  weekSalesByLabourHourTop: any;
  weekSalesByLabourHourBottom: any;
  weekSalesValueByItemTop: any;
  weekSalesValueByItemBottom: any;
  weekAverageOrderTop: any;
  weekAverageOrderBottom: any;
  GST_VALUE: any;
  targetImg: any;
  shopType: any;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      this.shopType = this.dashboardData?.sales_all_shops[0].shop_type;
      const dash_board_data = this.dashboardData?.dashboard_data_v3?.[0];
      // -------WEEK TO DATE Section-------
      // -------Sales Card (WEEK TO DATE Section)-------
      let this_week_sales = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_sales));
      this.weekSalesTop = this_week_sales;
      let label_1_2 = "-&nbsp;-";
      let last_year_same_week_sales = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_sales));
      if (last_year_same_week_sales > 0) {
        let this_week_sales_diff = this.setDecimalPoints(this_week_sales - last_year_same_week_sales);
        let this_week_sales_per = 0;
        if (last_year_same_week_sales != 0) {
          this_week_sales_per = this.setDecimalPoints(((this_week_sales - last_year_same_week_sales) / last_year_same_week_sales) * 100, 1);
        }
        label_1_2 =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(this_week_sales_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(this_week_sales - last_year_same_week_sales, '$', false, 0) + ' LY' + '</span>';
      }
      this.weekSalesBottom = label_1_2;

      // -------ONLINE SALES Card (WEEK TO DATE Section)-------
      let online_sales_weekly = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_online_sales));
      this.weekOnlineSalesTop = online_sales_weekly;
      let label_1_2_online = "--";
      let last_year_same_week_online_sales = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_online_sales));
      if (last_year_same_week_online_sales > 0) {
        let last_year_same_week_online_sales_diff = this.setDecimalPoints(online_sales_weekly - last_year_same_week_online_sales);
        let last_year_same_week_online_sales_per = 0;
        if (last_year_same_week_online_sales != 0) {
          last_year_same_week_online_sales_per = this.setDecimalPoints(((online_sales_weekly - last_year_same_week_online_sales) / last_year_same_week_online_sales) * 100, 1);
        }
        label_1_2_online =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(last_year_same_week_online_sales_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(online_sales_weekly - last_year_same_week_online_sales, '$', false, 0) + ' LY' + '</span>';
      }
      this.weekOnlineSalesBottom = label_1_2_online;

      // -------ONLINE CUSTOMER ORDERS Card (WEEK TO DATE Section)-------
      let online_sales_count_weekly = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_online_sales_count), 1);
      this.weekOnlineCustomerOrdersTop = online_sales_count_weekly;
      let label_1_2_orders = "--";
      let last_year_same_week_online_sales_count = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_online_sales_count), 1);
      if (last_year_same_week_online_sales_count > 0) {
        let online_sales_count_weekly_diff = this.setDecimalPoints(online_sales_count_weekly - last_year_same_week_online_sales_count, 1);
        let online_sales_count_weekly_per = 0;
        if (last_year_same_week_online_sales_count != 0) {
          online_sales_count_weekly_per = this.setDecimalPoints(((online_sales_count_weekly - last_year_same_week_online_sales_count) / last_year_same_week_online_sales_count) * 100, 1);
        }
        label_1_2_orders =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(online_sales_count_weekly_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(online_sales_count_weekly - last_year_same_week_online_sales_count, '', false, 0) + ' LY' + '</span>';
      }
      this.weekOnlineCustomerOrdersBottom = label_1_2_orders;

      // -------LABOUR % Card (WEEK TO DATE Section)-------
      this.GST_VALUE = dash_board_data?.gst_value ?? 1;
      let this_week_sales_wo_gst = this.setDecimalPoints(dash_board_data?.this_week_sales / this.GST_VALUE);
      let this_week_roster_sales_wo_gst = this.setDecimalPoints(dash_board_data?.this_week_target / this.GST_VALUE);
      let last_year_same_week_sales_wo_gst = this.setDecimalPoints(dash_board_data?.last_year_same_week_sales / this.GST_VALUE);
      let this_week_roster_labour_per = this.setDecimalPoints((dash_board_data?.this_week_roster_labor_cost / this_week_roster_sales_wo_gst) * 100);
      let last_year_this_week_labor_per = this.setDecimalPoints((dash_board_data?.last_year_same_week_acutal_labor_cost / last_year_same_week_sales_wo_gst) * 100);
      let this_week_labour_per = this.setDecimalPoints((dash_board_data?.this_week_labour_cost / this_week_sales_wo_gst) * 100);
      this.weekLabourPerTop = this_week_labour_per + '%';
      let this_week_roster_labour_per_diff = this.setDecimalPoints(this_week_labour_per - this_week_roster_labour_per);
      let this_week_labour_per_ly_diff = this.setDecimalPoints(this_week_labour_per - last_year_this_week_labor_per);
      const targetImg = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
      let label_1_2_labour =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(this_week_roster_labour_per_diff, '%', true, 1) + targetImg + ' &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(this_week_labour_per_ly_diff, '%', true, 1) + ' LY' + '</span>';
      this.weekLabourPerBottom = label_1_2_labour;

      // -------DRIVE-THRU SALES Card (WEEK TO DATE Section)-------
      let this_week_dt_sales = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_dt_sales));
      this.weekDriveThruSalesTop = this_week_dt_sales;
      let label_1_2_dt_sales = "--";
      let last_year_same_week_dt_sales = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_dt_sales));
      if (last_year_same_week_dt_sales > 0) {
        let last_year_same_week_dt_sales_diff = this.setDecimalPoints(this_week_dt_sales - last_year_same_week_dt_sales);
        let last_year_same_week_dt_sales_per = 0;
        if (last_year_same_week_dt_sales != 0) {
          last_year_same_week_dt_sales_per = this.setDecimalPoints(((this_week_dt_sales - last_year_same_week_dt_sales) / last_year_same_week_dt_sales) * 100, 1);
        }
        let arrow_1 = '';
        let arrow_2 = '';
        // If you have a custom up_arrow_or_down_arrow function, use it here. Otherwise, use the arrow from setFontColorWithUpDownArrow.
        // For now, just use empty strings as arrows are included in setFontColorWithUpDownArrow output.
        label_1_2_dt_sales =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(last_year_same_week_dt_sales_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(this_week_dt_sales - last_year_same_week_dt_sales, '$', false, 0) + ' LY' + '</span>';
      }
      this.weekDriveThruSalesBottom = label_1_2_dt_sales;

      // -------DRIVE-THRU ORDERS Card (WEEK TO DATE Section)-------
      let this_week_dt_sales_count = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_dt_sales_count), 1);
      this.weekDriveThruOrdersTop = this_week_dt_sales_count;
      let label_1_2_dt_orders = "--";
      let last_year_same_week_dt_sales_count = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_dt_sales_count), 1);
      if (last_year_same_week_dt_sales_count > 0) {
        let dt_sales_count_weekly_diff = this.setDecimalPoints(this_week_dt_sales_count - last_year_same_week_dt_sales_count, 1);
        let dt_sales_count_weekly_per = 0;
        if (last_year_same_week_dt_sales_count != 0) {
          dt_sales_count_weekly_per = this.setDecimalPoints(((this_week_dt_sales_count - last_year_same_week_dt_sales_count) / last_year_same_week_dt_sales_count) * 100, 1);
        }
        label_1_2_dt_orders =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(dt_sales_count_weekly_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(this_week_dt_sales_count - last_year_same_week_dt_sales_count, '', false, 0) + ' LY' + '</span>';
      }
      this.weekDriveThruOrdersBottom = label_1_2_dt_orders;

      // -------TARGET Card (WEEK TO DATE Section)-------
      let this_week_target = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_target));
      this.weekTargetTop = this_week_target;
      let this_week_target_diff = this.setDecimalPoints(this_week_sales - this_week_target);
      let this_week_target_per = 0;
      if (this_week_target != 0) {
        this_week_target_per = this.setDecimalPoints((this_week_target_diff / this_week_target) * 100, 1);
      }
      this.targetImg = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
      let label_1_week_target =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(this_week_target_per, "%", false, 1) + targetImg + ' &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(this_week_target_diff, "$", false, 0) + targetImg + ' &nbsp; ' + '</span>';
      this.weekTargetBottom = label_1_week_target;

      // -------LABOUR HOURS Card (WEEK TO DATE Section)-------
      const week_labour_hours = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_labour_hours), 0);
      this.weekLabourHoursTop = week_labour_hours;
      let label_week_labour_hours = "-&nbsp;-";
      const last_year_same_week_labor_hours = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_acutal_labor_hours), 0);
      if (last_year_same_week_labor_hours > 0) {
        const week_roster_labor_hours = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_roster_labor_hours), 0);
        const week_labour_hours_diff = this.setDecimalPoints(week_labour_hours - week_roster_labor_hours);
        const week_labour_hours_ly = this.setDecimalPoints(week_labour_hours - last_year_same_week_labor_hours);
        const targetImg = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
        label_week_labour_hours =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(week_labour_hours_diff, '', true, 0) + targetImg + ' &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(week_labour_hours_ly, '', true, 0) + ' LY' + '</span>';
      }
      this.weekLabourHoursBottom = label_week_labour_hours;

      // -------CUSTOMER ORDERS Card (WEEK TO DATE Section)-------
      const week_no_of_cust_orders = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_no_of_cust_orders), 0);
      this.weekCustomerOrdersTop = week_no_of_cust_orders;
      // console.log(this.weekCustomerOrdersTop)
      let label_week_customer_orders = "-&nbsp;-";
      let last_year_same_week_customer_orders = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_customer_orders), 0);
      if (last_year_same_week_customer_orders > 0) {
        let week_no_of_cust_orders_diff = this.setDecimalPoints(week_no_of_cust_orders - last_year_same_week_customer_orders, 0);
        let week_no_of_cust_orders_per = 0;
        if (last_year_same_week_customer_orders !== 0) {
          week_no_of_cust_orders_per = this.setDecimalPoints((week_no_of_cust_orders_diff / last_year_same_week_customer_orders) * 100, 1);
        }
        label_week_customer_orders =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(week_no_of_cust_orders_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(week_no_of_cust_orders_diff, '', false, 0) + ' LY' + '</span>';
      }
      this.weekCustomerOrdersBottom = label_week_customer_orders;
      // -------LABOUR COST Card (WEEK TO DATE Section)-------
      const week_labour_cost = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_labour_cost), 0);
      this.weekLabourCostTop = week_labour_cost;
      let label_week_labour_cost = "-&nbsp;-";
      const week_roster_labor_cost = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_roster_labor_cost), 0);
      const last_year_same_week_acutal_labor_cost = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_acutal_labor_cost), 0);
      if (last_year_same_week_acutal_labor_cost > 0) {
        const week_labour_cost_roster_diff = this.setDecimalPoints(week_labour_cost - week_roster_labor_cost, 0);
        const week_labour_cost_diff = this.setDecimalPoints(week_labour_cost - last_year_same_week_acutal_labor_cost, 0);
        const targetImg = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
        label_week_labour_cost =
          this.setFontColorWithUpDownArrow(week_labour_cost_roster_diff, '$', true, 0) + targetImg + ' &nbsp; ' +
          this.setFontColorWithUpDownArrow(week_labour_cost_diff, '$', true, 0) + 'LY ';
      }
      this.weekLabourCostBottom = label_week_labour_cost;
      // -------ITEM SOLD Card (WEEK TO DATE Section)-------
      const week_items_sold = this.setDecimalPoints(this.fn_check_null(dash_board_data?.this_week_items_sold), 0);
      this.weekItemsSoldTop = week_items_sold;
      let label_week_items_sold = "-&nbsp;-";
      const last_year_same_week_items_sold = this.setDecimalPoints(this.fn_check_null(dash_board_data?.last_year_same_week_items_sold), 0);
      if (last_year_same_week_items_sold > 0) {
        const week_items_sold_diff = this.setDecimalPoints(week_items_sold - last_year_same_week_items_sold, 0);
        let week_items_sold_per = 0;
        if (last_year_same_week_items_sold !== 0) {
          week_items_sold_per = this.setDecimalPoints((week_items_sold_diff / last_year_same_week_items_sold) * 100, 1);
        }
        label_week_items_sold =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(week_items_sold_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(week_items_sold_diff, '', false, 0) + ' LY' + '</span>';
      }
      this.weekItemsSoldBottom = label_week_items_sold;
      // -------SALES / LABOUR HOUR Card (WEEK TO DATE Section)-------
      let week_sales_by_labour_hour = 0;
      if (this_week_sales && week_labour_hours) {
        week_sales_by_labour_hour = this.setDecimalPoints(this_week_sales / week_labour_hours, 2);
      }
      this.weekSalesByLabourHourTop = week_sales_by_labour_hour;
      let label_week_sales_by_labour_hour = "-&nbsp;-";
      let last_year_week_sales_by_labour_hour = 0;
      if (last_year_same_week_sales && last_year_same_week_labor_hours) {
        last_year_week_sales_by_labour_hour = this.setDecimalPoints(last_year_same_week_sales / last_year_same_week_labor_hours, 2);
      }
      if (last_year_week_sales_by_labour_hour > 0) {
        const week_sales_by_labour_hour_ly_diff = this.setDecimalPoints(week_sales_by_labour_hour - last_year_week_sales_by_labour_hour, 0);
        const week_sales_by_labour_hour_per = this.setDecimalPoints((week_sales_by_labour_hour_ly_diff / last_year_week_sales_by_labour_hour) * 100, 1);
        label_week_sales_by_labour_hour =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(week_sales_by_labour_hour_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(week_sales_by_labour_hour_ly_diff, '$', false, 0) + ' LY' + '</span>';
      }
      this.weekSalesByLabourHourBottom = label_week_sales_by_labour_hour;
      // -------SALES VALUE / ITEM Card (WEEK TO DATE Section)-------
      let week_sales_value_by_item = 0;
      let label_week_sales_value_by_item = "-&nbsp;-";
      if (this_week_sales && dash_board_data?.this_week_items_sold) {
        week_sales_value_by_item = this.setDecimalPoints(this_week_sales / dash_board_data.this_week_items_sold, 1);
      }
      this.weekSalesValueByItemTop = week_sales_value_by_item;
      let last_year_week_sales_value_by_item = 0;
      if (last_year_same_week_sales && dash_board_data?.last_year_same_week_items_sold) {
        last_year_week_sales_value_by_item = this.setDecimalPoints(last_year_same_week_sales / dash_board_data.last_year_same_week_items_sold, 1);
      }
      if (last_year_week_sales_value_by_item > 0) {
        const week_sales_value_by_item_diff = this.setDecimalPoints(week_sales_value_by_item - last_year_week_sales_value_by_item, 0);
        const week_sales_value_by_item_per = this.setDecimalPoints((week_sales_value_by_item_diff / last_year_week_sales_value_by_item) * 100, 1);
        label_week_sales_value_by_item =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(week_sales_value_by_item_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(week_sales_value_by_item_diff, '$', false, 2) + ' LY' + '</span>';
      }
      this.weekSalesValueByItemBottom = label_week_sales_value_by_item;
      // -------AVERAGE ORDER $ Card (WEEK TO DATE Section)-------
      let week_average_order = 0;
      let label_week_average_order = "-&nbsp;-";
      if (this_week_sales && week_no_of_cust_orders) {
        week_average_order = this.setDecimalPoints(this_week_sales / week_no_of_cust_orders, 2);
      }
      this.weekAverageOrderTop = week_average_order;
      let last_year_week_average_order = 0;
      if (last_year_same_week_sales && last_year_same_week_customer_orders) {
        last_year_week_average_order = this.setDecimalPoints(last_year_same_week_sales / last_year_same_week_customer_orders, 2);
      }
      if (last_year_week_average_order > 0) {
        const week_average_order_diff = this.setDecimalPoints(week_average_order - last_year_week_average_order, 0);
        const week_average_order_per = this.setDecimalPoints((week_average_order_diff / last_year_week_average_order) * 100, 1);
        label_week_average_order =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(week_average_order_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(week_average_order_diff, '$', false, 0) + ' LY' + '</span>';
      }
      this.weekAverageOrderBottom = label_week_average_order;

    }
  }
  ngOnInit() { }

  setFontColorWithUpDownArrow(
    numberForSet: number,
    symbol: string = '',
    reverse: boolean = false,
    decimal: number = 1
  ): string {
    if (isNaN(numberForSet)) {
            return '-- ';
        }
    let baseNumber: string | number = numberForSet;
    let numberWithSymbol: string;

    if (symbol === '%') {
      baseNumber = Number(numberForSet).toLocaleString('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
      });
      numberWithSymbol = baseNumber + symbol;
    } else if (symbol === '$') {
      baseNumber = Number(numberForSet).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: decimal,
      });
      numberWithSymbol = baseNumber as string;
    } else {
      numberWithSymbol = Number(numberForSet).toLocaleString('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: decimal,
      });
    }

    let arrow = '';
    if (Math.sign(numberForSet) === 1) {
      arrow = '▲';
    } else if (Math.sign(numberForSet) === -1) {
      arrow = '▼';
    }

    const compareValue = reverse ? numberForSet * -1 : numberForSet;

    if (Math.sign(compareValue) === 0) {
      return numberWithSymbol;
    } else if (Math.sign(compareValue) === 1) {
      let colorWithNumber = `<span class='cgreen'>${numberWithSymbol}${arrow}</span>`;
      colorWithNumber = colorWithNumber.replace('-', '');
      return colorWithNumber;
    } else if (Math.sign(compareValue) === -1) {
      let colorWithNumber = `<span class='cred'>${numberWithSymbol}${arrow}</span>`;
      colorWithNumber = colorWithNumber.replace('-', '');
      return colorWithNumber;
    } else {
      return numberWithSymbol;
    }
  }

  setDecimalPoints(value: number, decimal: number = 1): number {
    return Number(Number(value).toFixed(decimal));
  }
  fn_check_null(a: any): number {
    return a == null ? 0 : a;
  }
}
